module.exports = __webpack_public_path__ + "img/ysgj_006@2x.62dab9cc.png";